module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm6.73a1c55629314b2c83c695900364f91f.png";